import React from 'react';
import { observer } from 'mobx-react-lite';
import { Header } from 'src/domains/layouts/shared/cms/header/header';
import { useAppStateContext } from 'src/AppState/AppState';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import {
    ComplianceConfigurationContent,
    ComplianceConfigurationPage,
    ComplianceConfigurationToolbar,
    ComplianceConfigurationWrapper,
} from 'src/components/ComplianceConfiguration/ComplianceConfiguration.style';
import { ComplianceConfigurationTabs } from 'src/components/ComplianceConfiguration/ComplianceConfigurationTabs';
import { GamstopPreviouslyPositive } from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive';
import { ComplianceConfigurationLicenseConfig } from 'src/components/ComplianceConfiguration/LicenseConfig/ComplianceConfigurationLicenseConfig';
import { AutoLogout } from 'src/components/ComplianceConfiguration/AutoLogout/AutoLogout';
import { ActivityTimeframe } from 'src/components/ComplianceConfiguration/ActivityTimeframe/ActivityTimeframe';
import { MarkersOfHarmPopupTab } from 'src/components/FraudAndCompliance/MarkersOfHarmPopupTab/MarkersOfHarmPopupTab';

export const ComplianceConfiguration = observer((): JSX.Element => {
    const { routerBackoffice } = useAppStateContext();
    const { config } = ConfigState.get(useCommon());
    const activeSubTab = routerBackoffice.getParametersString('global', 'tab.tab') ?? 'gamstop-previously-positive';

    const renderContent = (): JSX.Element => {
        if (activeSubTab === 'license-config') {
            return <ComplianceConfigurationLicenseConfig />;
        }

        if (activeSubTab === 'auto-logout') {
            return <AutoLogout />;
        }

        if (activeSubTab === 'activity-timeframe' && config.activityTimeframe) {
            return <ActivityTimeframe />;
        }

        if (activeSubTab === 'markers-of-harm-popup' && config.markersOfHarm) {
            return <MarkersOfHarmPopupTab />;
        }

        return <GamstopPreviouslyPositive />;
    };

    return (
        <ComplianceConfigurationWrapper data-test='compliance-configuration'>
            <ComplianceConfigurationPage>
                <ComplianceConfigurationToolbar>
                    <Header title='Compliance Configuration' />

                    <ComplianceConfigurationTabs />
                </ComplianceConfigurationToolbar>

                <ComplianceConfigurationContent>{renderContent()}</ComplianceConfigurationContent>
            </ComplianceConfigurationPage>
        </ComplianceConfigurationWrapper>
    );
});
